import api from './api';

export interface DashboardKPI {
    previsto: number;
    realizado: number;
}

export interface DashboardMovimentacao {
    id: number;
    tipo: 'receita' | 'despesa';
    descricao: string;
    entidade_nome: string | null;
    valor: number;
    data: string;
    status: 'pago' | 'pendente' | 'vencido' | 'cancelado';
}

export interface DashboardData {
    receitas: DashboardKPI;
    despesas: DashboardKPI;
    saldo: DashboardKPI;
    /** @deprecated mantido por compatibilidade — usar saldo.realizado */
    saldoAtual: number;
    /** @deprecated mantido por compatibilidade — usar saldo.previsto */
    diferenca: number;
    movimentacoes: DashboardMovimentacao[];
}

export const dashboardService = {
    getSummary: async (mes?: string, ano?: string): Promise<DashboardData> => {
        const response = await api.get('/dashboard', { params: { mes, ano } });
        return response.data;
    }
};
